module.exports = __webpack_public_path__ + "static/img/6.05e6ff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/6.svg
// module id = 577
// module chunks = 1